import React from "react";
import { AvFeedback, AvForm, AvGroup, AvInput } from "availity-mobx-reactstrap-validation";
import ErrorDisplay from "js/components/common/ErrorDisplay";
import PageComponent from "js/components/pages/PageComponent";
import { lightGrey1Color } from 'js/config/style';
import analytics from 'js/services/Analytics';
import { makeRequest, navigate, url } from 'js/services/Network';
import userCountry from "js/services/UserCountry";
import AppState from 'js/stores/AppState';
import AppUser from 'js/stores/AppUser';
import { observer } from 'mobx-react';
import StepPage from "./StepPage";
import Button from 'js/components/common/Button';

@observer
export default class StoreCreatedAddPhone extends PageComponent {
  pageName = 'StoreCreatedAddPhone';
  trackingName = 'SP_create_link';
  pageColor = lightGrey1Color;
  pageWidth = '1200px';

  constructor(props) {
    super(props);
    this.state = {
      requestInProgress: 0,
      errorMessage: null,
      editName: 0,
      editInput: null,
      name: AppUser.isLoggedIn ? AppUser.login : '',
      step1: 1,
      step2: 0,
      step3: 0,
    };
  }

  pageEvent = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('cv')) {
      analytics.goal('landing_conversion');
    }
    if (AppUser.isLoggedIn && AppUser.phone_number) {
      let alias = localStorage.getItem('most_recent_item');
      navigate(url('seller-payment-link-page', { alias }, null));
    }
  };

  backNav = () =>
    AppUser.isLoggedIn
      ? AppState.previousPage === 'UserDashboardPage'
        ? {
          mode: 'back',
          text: 'Dashboard',
          url: url('user-dashboard-page'),
        }
        : {
          mode: 'back',
          text: 'My items',
          url: url('my-items-page'),
        }
      : { mode: 'normal' };

  saveName = () => {
    this.setState({ requestInProgress: 1 })

    makeRequest('update-login', null, { login: this.state.name })
      .then(response => {
        this.setState({ requestInProgress: 0 })
        this.setState({ editName: 0 })
      })
      .catch(error => {
        this.setState({ requestInProgress: 0 });
      });
  }

  phoneSubmitted = (event, errors, formValues) => {
    event.preventDefault();
    if (this.state.requestInProgress === 0) {
      this.setState({ requestInProgress: 1 })

      makeRequest('store-created-save-phone', null, formValues)
        .then(response => {
          this.setState({ requestInProgress: 0 })
          const alias = response.data.alias;

          navigate(url('seller-payment-link-page', { alias }, null));
        })
        .catch(error => {
          this.setState({ requestInProgress: 0 })
        })
    }
  }

  handleChangeTitle = (v) => {
    this.setState(() => ({
      name: v.target.value,
    }))
  }

  renderPage() {
    const page = this.props.page;

    return (
      <StepPage current={2} page={page}>
        <div className="tw-flex tw-items-center tw-gap-4">
          <p className="tw-font-bold">Congratulations!</p>
          <img
            src="/images/v2/congratulations.png"
            alt="items"
            className="size-18px"
          />
        </div>

        <div className="md:tw-w-full">

          <p className="tw-mb-10" style={{ font: 'inter', fontWeight: '200', fontSize: '16px', lineHeight: '27px' }}>
            Your store has been created. We have given your store a name. You can change the name below
          </p>

          <div className="store-name d-flex align-items-center justify-content-between tw-mb-1">
            {this.state.editName === 1 ? (
              <input type="text" value={this.state.name} className="me-2" onChange={this.handleChangeTitle} />
            ) : (
              <h2><span style={{ font: 'inter', fontWeight: '450', fontSize: '18px', lineHeight: '27px', paddingLeft: '1px' }}>Shop {this.state.name ?? 'Loading...'}</span></h2>
            )}
            {this.state.editName === 1 ? (
              <>
                <button
                  className='btn btn-pod btn-secondary outline d-flex'
                  onClick={() => this.setState({ editName: 0 })}
                  disabled={this.state.requestInProgress === 1}
                >
                  Cancel
                </button>
                <button
                  className='btn btn-pod btn-light-purple outline d-flex'
                  onClick={this.saveName}
                  disabled={this.state.requestInProgress === 1}
                >
                  Save
                </button>
              </>
            ) : (
              <button
                className="float-end btn btn-pod btn-third tw-py-1 tw-rounded-lg tw-text-black tw-pr-1 tw-pl-1 btn-sm tw-text-sm"
                onClick={() => this.setState({ editName: 1 })}>
                <img
                  src="/images/icons/pencil.svg"
                  alt="items"
                  className="size-24px tw-pb-[5px]"
                />
                Edit store name
              </button>
            )}
          </div>

          <span className="clearfix" style={{ clear: 'both' }}>&nbsp;</span>

          <AvForm onSubmit={this.phoneSubmitted}>
            <AvGroup className="tw-w-full tw-mt-6 ">
              <label
                htmlFor="tw-instagram-handle"
                className="tw-block tw-mb-2 tw-text-base tw-font-medium tw-text-primary">
                Whatsapp number
              </label>

              <div className="row">
                <div className="col-3">
                  <AvInput
                    type="text"
                    name="prefix"
                    id="tw-prefix"
                    value={userCountry === 'US' ? '+1' : '+234'}
                    aria-describedby="tw-helper-text-explanation"
                    className="tw-bg-white tw-border tw-border-outline tw-placeholder-[#6C7277] tw-text-primary tw-font-medium tw-text-sm tw-rounded-lg tw-w-full tw-p-3"
                  />
                </div>

                <div className="col-9">
                  <AvInput
                    type="text"
                    name="phone"
                    id="tw-phone"
                    required
                    aria-describedby="tw-helper-text-explanation"
                    className="tw-bg-white tw-border tw-border-outline tw-placeholder-[#6C7277] tw-text-primary tw-font-medium tw-text-sm tw-rounded-lg tw-w-full tw-p-3"
                    placeholder={"Input your phone number"}
                  />
                </div>
              </div>
              <AvFeedback>Please enter your valid whatsapp number</AvFeedback>
            </AvGroup>

            <div style={{ background: '#F1F0FF' }}>
              <p style={{ padding: '10px' }}>
                <img
                  src="/images/v2/essential.png"
                  alt="items"
                  className="size-18px"
                />&nbsp;
                Your WhatsApp number is needed for order notification and delivery pickup purposes. This number will not be made public
              </p>
            </div>

            <Button
              type="submit"
              isLoading={false}
              disabled={false}
              onClick={() => { }}>
              Continue
            </Button>

            <ErrorDisplay>{this.state.errorMessage}</ErrorDisplay>
          </AvForm>
        </div>
      </StepPage>
    )
  }
}
